import encryptWays from "./encryptionWay";
import Player from "../Models/Player";
import Utils from "./Utils";
import Constant from "./Constant";

export default class Network {
    // 普通请求
    static httpRequest (params) {
        cc.log('请求URL:', params.url)

        if (cc.sys.isBrowser) {
            cc.log('发送数据:', params.data)
        }else {
            cc.log('发送数据:', JSON.stringify(params.data))
        }
        
        let urlStr = params.url
        let methodStr = params.method || 'GET'
        let responseType = params.responseType || 'json'
        let token = Player.getPy("token")
    
        let xhr = new XMLHttpRequest()
        xhr["params"] = params
        xhr.responseType = responseType
        xhr.onload = function () {
            if (xhr.status === 200){
                if (cc.sys.isBrowser) {
                    cc.log('收到数据:', xhr.response)
                }else {
                    cc.log('收到数据:', JSON.stringify(xhr.response))
                }
                
                params.cb && params.cb(null, xhr.response, xhr["params"])
            }else{
                cc.error("请求失败：status = " + xhr.status)
                params.cb && params.cb("请求失败", null, xhr["params"])
            }
        }

        xhr.onerror = function () {
            // 延时一下显示效果更好
            setTimeout(function () {
                cc.error("网络错误")
                params.cb && params.cb("网络错误", null, xhr["params"])
            }, 1000)
        }

        xhr.timeout = 20000
    
        xhr.ontimeout = function (e) {
            // XMLHttpRequest 超时。在此做某事。
            cc.error("请求超时")
            params.cb && params.cb("请求超时", null, xhr["params"])
        }

        xhr.open(methodStr, urlStr, true)

        // ------设置请求头------
        let requestHeader = {
            "Content-Type": "application/json",
            "deviceModel": cc.sys.isMobile ? jsb.device.getDeviceModel() : "",  // 设备型号
            "deviceFlag": Utils.getDeviceId(),                                  // 设备ID
            "templateId": cc.sys.localStorage.getItem("TemplateID"),                                                  // 模板id
            "deviceType": cc.sys.os === cc.sys.OS_ANDROID ? "1" : "2",          // 设备类型
            "languageType": cc.sys.localStorage.getItem("CurrentLanguage"),
        }

        // 外部传进来的requestHeader
        for (const key in params.requestHeader) {
            requestHeader[key] = params.requestHeader[key]
        }

        for (const key in requestHeader) {
            xhr.setRequestHeader(key, requestHeader[key])
        }

        // 加入授权
        if (token) {
            xhr.setRequestHeader("Authorization", "Bearer_" + token)
        }
        
        if (!!params.data) {
            let data = JSON.stringify(params.data)

            if(data.length > 0){
                let requestData = data

                if (!params.ignoreEncryption) {
                    if (Constant.TestEncrypt) {
                        let aesKey = "AAAAAAAAAAAAAAAA";
                        requestData = encryptWays.sevenEncrypt(data, aesKey, aesKey)
                    }else {
                        let aesKey = token ? token.substring(token.length - 16) : ""
                        requestData = encryptWays.fourEncrypt(data, aesKey, aesKey)
                    }
                }
                
                xhr.send(requestData)
            }else{
                xhr.send()
            }
        } else {
            xhr.send()
        }
    }

    // 上传文件请求
    static uploadRequest (params) {
        cc.log('请求URL:', params.url)
        
        let urlStr = params.url
        let methodStr = params.method || 'GET'
        let responseType = params.responseType || 'json'
        let fileName = params.data.fileName
        let fileData = params.data.fileData

        if (!fileName) {
            cc.log("上传文件名不能呢为空")
            return
        }
        
        if (!fileData) {
            cc.log("上传文件数据不能为空")
            return
        }
    
        let xhr = new XMLHttpRequest()
        xhr["params"] = params
        xhr.responseType = responseType

        xhr.onload = function () {
            if (xhr.status === 200){
                if (cc.sys.isBrowser) {
                    cc.log('收到数据:', xhr.response)
                }else {
                    cc.log('收到数据:', JSON.stringify(xhr.response))
                }

                params.cb && params.cb(null, xhr.response, xhr["params"])
            }else{
                cc.error("请求失败：status=" + xhr.status)
                params.cb && params.cb("请求失败", null, xhr["params"])
            }
        }

        xhr.onerror = function () {
            // 延时一下显示效果更好
            setTimeout(function () {
                cc.error("网络错误")
                params.cb && params.cb("网络错误", null, xhr["params"])
            }, 1000)
        }

        xhr.timeout = 60000
    
        xhr.ontimeout = function (e) {
            // XMLHttpRequest 超时。在此做某事。
            cc.error("请求超时")
            params.cb && params.cb("请求超时", null, xhr["params"])
        }

        // 构造FormData格式
        let boundary = `----${Utils.randomString()}`
        let str = `\r\n--${boundary}\r\n`

        str = str + `Content-Disposition: form-data; name="file"; filename="${fileName}"\r\n`
        str = str + "Content-Type: application/octet-stream\r\n\r\n"
        str = str + Utils.uint8Array2String(fileData)
        str = str + `\r\n--${boundary}--\r\n`
            
        xhr.open(methodStr, urlStr, true)
        xhr.setRequestHeader("Content-Type", "multipart/form-data; boundary = " + boundary)
        xhr.send(Utils.string2Uint8Array(str))
    };
}